<template lang="pug">
div
  Header(current="profiles")
  #profilingForm.c-progress-form(@click="computePercentage")
    .row
      .column
        ProgressForm
          YesNoQuestion(attribute="liberal_profession" yes_icon="choice-check" v-if="liberalProfession")
          YesNoQuestion(attribute="has_children" yes_icon="choice-kids")
          House
          YesNoQuestion(attribute="often_traveling_abroad" yes_icon="choice-plane")
          YesNoQuestion(attribute="often_doing_sport" yes_icon="choice-sport")
          YesNoQuestion(attribute="has_digital_devices" yes_icon="device-phone")
          YesNoQuestion(attribute="has_pet" yes_icon="choice-pets")
          Vehicles(name="number_of_cars")
          Vehicles(name="number_of_vans")
          Vehicles(name="number_of_motorbikes")
          Salary

    ProgressBar(next="insurances" :percent="percentage" spinnerTime=2000)
</template>

<script>
import Header from './shared/Header'
import YesNoQuestion from './profiles/YesNoQuestion'
import House from './profiles/House'
import Vehicles from './profiles/Vehicles'
import Salary from './profiles/Salary'
import ProgressBar from './shared/ProgressBar'
import ProgressForm from './shared/ProgressForm'

export default {
  data () {
    return {
      percentage: 0
    }
  },
  created () {
    document.title = 'Seraphin - Check-up - Profil'
  },
  mounted () {
    this.computePercentage()
  },
  components: {
    Header,
    YesNoQuestion,
    House,
    Vehicles,
    Salary,
    ProgressBar,
    ProgressForm
  },
  computed: {
    liberalProfession () {
      return this.$store.getters.isIndependent
    }
  },
  methods: {
    computePercentage () {
      this.percentage = (this.$el.querySelectorAll('input:checked').length / this.$el.querySelectorAll('.c-progress-form__element').length) * 100
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Profiles.vue